import { useEffect, useState } from 'react'
import { useWindowScroll, useWindowSize } from 'react-use'
import { DonateButton } from 'ppp'

export const StickyPhone = (props) => {
  const [visible, setVisible] = useState(false)
  const [left, setLeft] = useState(0)

  const handleScroll = () => {
    var triggerDistance = document.querySelector('#ppp-sticky-anchor').getBoundingClientRect().top
    var untriggerDistance = document.querySelector('footer').getBoundingClientRect().top - window.innerHeight
    if (triggerDistance <= 0 && untriggerDistance >= 0) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }

  const handleResize = () => {
    let bodyLeft = document.querySelector('body').getBoundingClientRect().left
    if (bodyLeft < 0) bodyLeft = 0
    setLeft(bodyLeft)
  }

  const { y } = useWindowScroll()
  useEffect(() => { y == 0 || handleScroll() }, [y])
  const { width, height } = useWindowSize()
  useEffect(() => { width && handleResize() }, [width, height])

  return <div className="phone-sticky-wrapper" style={{ opacity: visible ? 1 : 0, left: left }}>
    <div className="sticky-wrapper justify-between items-center flex">
      <DonateButton project={props.project} status={props.status} gaAction='click donate_button__sticky' />
    </div>
  </div>
}
